<script>
  import { doneTasks } from './stores.js';

  let goals = [
    { id: "day", label: "Today", period: 86400, count: 8, doneCount: 0 },
    { id: "week", label: "This week", period: 86400 * 7, count: 40, doneCount: 0 },
  ];

  function clearAll() {
    doneTasks.set([]);
  }

  function updateGoals(doneTasks) {
    console.log(doneTasks);
    let now = Date.now()
    goals.forEach(goal => {
      goal.doneCount = doneTasks.filter(t => t.time >= now - goal.period * 1000).length
    });
    goals = goals
  }

  $: updateGoals($doneTasks);
</script>

<div class="box goals">
  <h2>Goals</h2>
  {#each goals as goal}
    <div>
      <h3>{goal.label}</h3>
      <div class="goalBox">
        {#each {length: Math.max(goal.count, goal.doneCount)} as _, i}
          <span class="goal" class:done={i < goal.doneCount}></span>
        {/each}
      </div>
    </div>
  {/each}
  {#if IS_DEV}
    <img
      class="action corner-button"
      src="/cross.png"
      on:click={clearAll}
    />
  {/if}
</div>

<style>
  .goalBox {
    line-height: 0;
    margin: 0.2em;
  }
  .goal {
    display: inline-block;
    height: 1em;
    width: 1em;
    border: 1px solid black;
    margin: 0.1em;
  }
  .goal.done {
    background: #256f5b;
  }
</style>
